// Remove stale service worker/caches from previous gatsby-plugin-offline deployments.
exports.onClientEntry = () => {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          const workerScript =
            registration.active?.scriptURL ||
            registration.waiting?.scriptURL ||
            registration.installing?.scriptURL ||
            "";

          if (workerScript.includes("/sw.js")) {
            registration.unregister().catch(() => {});
          }
        });
      })
      .catch(() => {});

    if (!("caches" in window)) return;

    caches
      .keys()
      .then((keys) =>
        Promise.all(
          keys
            .filter(
              (key) =>
                key.includes("gatsby-plugin-offline") ||
                key.includes("workbox-precache") ||
                key.includes("gatsby")
            )
            .map((key) => caches.delete(key))
        )
      )
      .catch(() => {});
  });
};

const DEFAULT_GA4_MEASUREMENT_ID = "G-SCE6V2KYTT";

function getGa4MeasurementId() {
  const explicit = process.env.GATSBY_GA_MEASUREMENT_ID;
  return (explicit && explicit.trim()) || DEFAULT_GA4_MEASUREMENT_ID;
}

exports.onRouteUpdate = ({ location }) => {
  if (process.env.GATSBY_GA_DISABLED === "true") return;

  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  const measurementId = getGa4MeasurementId();
  if (!measurementId) return;

  const page_path = `${location.pathname}${location.search || ""}${location.hash || ""}`;
  window.gtag("config", measurementId, { page_path });
};
